import { call, put, takeEvery, select } from "redux-saga/effects";
import axios from "axios";
import * as actions from "actions";
import api from "api";
import * as Types from "Types";
import * as constants from "GlobalConstants";

function* getContents(action: any) {
   const instance = axios.create({ baseURL: constants.baseUri });

   instance.interceptors.request.use(function (req) {
      const formData = new FormData();

      const data = req.data || req.params || {};

      Object.keys(data).forEach(function (k) {
         formData.append(k, data[k]);
      });
      req.headers = { "Content-Type": "aplication/json" };

      req.data = formData;
      req.params = formData;

      return req;
   });
   instance.interceptors.response.use((res) => {
      return {
         code: res.data.code || res.status,
         data: res.data.data || [],
         message: res.data.message || "",
      };
   });

   const status: string = yield select(function (state: any) {
      return state.nowContents.get.status;
   });
   if (status === api.statuses.pending) return;
   try {
      yield put({
         type: actions.nowContents.get.send,
      });

      const response: Types.Api.Response = yield call(instance, "/getContents/?now_id=" + action.data.now_id, { method: "get" });

      yield put({
         type: actions.nowContents.get.success,
         payload: { code: 200, data: response.data },
      });
   } catch (error) {
      console.log("error", error);
      yield put({
         type: actions.nowContents.get.fail,
         payload: {
            code: 400,
            message: "파라미터가 올바르지 않음",
         },
      });
   }
}

export function* nowsSaga() {
   yield takeEvery(actions.nowContents.get.call, getContents);
}
